export const PENDING_TIMESHEETS = 'pendingTimesheets';
export const TIMESHEET_PACKAGE = 'timesheetPackage';
export const EDIT_TIME_ENTRIES = 'editTimeEntry';
export const APPROVE = 'approve';
export const APP_CONFIG = 'appConfig';
